export interface SalesInvoiceDespatchItemAddRemove {
  salesInvoiceHeaderId: string;
  salesDespatchItemId: string;
}
